import { createStylesMap } from 'app/theme/materialTheme';

export const styles = createStylesMap({
  centeredText: {
    textAlign: 'center',
  },
});
